import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';


import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const assignProductUserEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignProductUserEntitlementsState', undefined);

export const assignProductUserEntitlementsStateActions = assignProductUserEntitlementsStateSlice.actions;
export const assignProductUserEntitlementsStateSelector:
CachedTableStateSelector<undefined, undefined, {resourceIds?: string[], resourceQuery: string}>
    = state => state.userPage.assignProductEntitlements.state;
